import { render, staticRenderFns } from "./DistanceBlock.vue?vue&type=template&id=4ac8990a&"
import script from "./DistanceBlock.vue?vue&type=script&lang=js&"
export * from "./DistanceBlock.vue?vue&type=script&lang=js&"
import style0 from "./DistanceBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports